<div class="ui-inline-message" [class] = "type">
    <i *ngIf = "icon" class = "ui-icon" [class] = "getIcon()" [style.font-size] = "iconFontSize"></i>
    <p class = "ui-inline-message-text">{{ message }}</p>
</div>
